/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Step_ReviewInputs */

const en_directory_agents_step_review = /** @type {(inputs: Directory_Agents_Step_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submits the content for human editorial review. Seek AI's GEO and AI-readiness audits run on the platform's own afterwards — scores never come from the agent.`)
};

const zh_directory_agents_step_review = /** @type {(inputs: Directory_Agents_Step_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交内容并进入人工编辑审核。GEO 与 AI-readiness 审计由平台在此后自行运行——评分永远不来自 agent。`)
};

/**
* | output |
* | --- |
* | "Submits the content for human editorial review. Seek AI's GEO and AI-readiness audits run on the platform's own afterwards — scores never come from the agent." |
*
* @param {Directory_Agents_Step_ReviewInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_step_review = /** @type {((inputs?: Directory_Agents_Step_ReviewInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Step_ReviewInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_step_review(inputs)
	return zh_directory_agents_step_review(inputs)
});
export { directory_agents_step_review as "directory.agents.step_review" }